export const SIDEBAR_WIDTH_VAR = "--sidebar-width";
export const DEFAULT_SIDEBAR_WIDTH = "0px";

export const LAYOUT_VIEWPORT_WIDTH_VAR = "--layout-viewport-width";
export const VW_UNIT_VAR = "--vw";

export const LAYOUT_VIEWPORT_WIDTH_FORMULA = `calc(100vw - var(${SIDEBAR_WIDTH_VAR}, ${DEFAULT_SIDEBAR_WIDTH}))`;

export function adaptThemeVwToLayoutUnit(css: string): string {
  if (!css || !/-?\d*\.?\d+vw\b/.test(css)) {
    return css;
  }
  return css.replace(/(-?\d*\.?\d+)vw\b/g, "calc($1 * var(--vw))");
}
